// src/Page/AdminPanel/index.js
import React from 'react';
import { useTheme } from '../../Context/ThemeContext';
import { useRole } from '../../Context/RoleContext';
import UserManagement from '../../Components/UserManagement';
import { Navigate } from 'react-router-dom';
import './index.css';

const AdminPanel = () => {
  const { isDarkMode } = useTheme();
  const { isAdmin } = useRole();

  if (!isAdmin()) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className={`admin-panel ${isDarkMode ? 'dark-mode' : ''}`}>
      <UserManagement />
    </div>
  );
};

export default AdminPanel;
